import dayjs from 'dayjs';

export const calculateTripDuration = (dateStart, dateEnd) => {
  return dayjs(dateEnd).diff(dayjs(dateStart), 'days') + 1;
};
